import { useState, useEffect } from "react";
import api from '../config/api';
import Select from "react-select";

export default function CreateStorageTransactionModal({ show, onClose, onSuccess }) {
  const [step, setStep] = useState(""); // "in" or "out"
  const [form, setForm] = useState({
    item_id: "",
    villa_id: "",
    quantity: "",
    transaction_type: "",
    price_per_unit: "",
    supplier_name: "",
    description: "",
    updated_at: new Date().toISOString().slice(0, 16),
  });

  const [items, setItems] = useState([]);
  const [villas, setVillas] = useState([]);
  const itemOptions = items.map((item) => ({
    value: item.id,
    label: `${item.code} - ${item.description}`,
  }));
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchItems = async () => {
      const token = localStorage.getItem("token");
      const response = await fetch(api("/items"), {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      setItems(data);
    };

    const fetchVillas = async () => {
      const token = localStorage.getItem("token");
      const response = await fetch(api("/villas"), {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      setVillas(data);
    };

    fetchItems();
    fetchVillas();
  }, []);

  const parseJwt = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(window.atob(base64));
    } catch (e) {
      console.error("Failed to parse JWT:", e);
      return null;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const user = parseJwt(token);
    const user_id = user?.user_id;

    // Basic validation
    const errors = [];

    if (!step) errors.push("Transaction type not selected.");
    if (!form.item_id) errors.push("Item is required.");
    if (!form.quantity || Number(form.quantity) <= 0) errors.push("Quantity must be more than 0.");
    if (!form.description) errors.push("Description is required.");
    if (!form.updated_at) errors.push("Date is required.");

    if (step === "in") {
      if (!form.price_per_unit || Number(form.price_per_unit) <= 0) errors.push("Price per unit required.");
      if (!form.supplier_name) errors.push("Supplier name required.");
    }

    if (step === "out") {
      if (!form.villa_id) errors.push("Villa is required.");
    }

    if (errors.length > 0) {
      setErrorMessage(errors.join(" "));
      return;
    }

    const payload = {
      item_id: Number(form.item_id),
      user_id,
      villa_id: form.villa_id ? Number(form.villa_id) : null,
      quantity: Number(form.quantity),
      transaction_type: step,
      price_per_unit: form.price_per_unit ? Number(form.price_per_unit) : null,
      supplier_name: form.supplier_name || null,
      description: form.description,
      updated_at: new Date(form.updated_at).toISOString(),
    };

    try {
      console.log("ini payload : ",payload)
      const response = await fetch(api("/storage-transactions"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.error || "Failed to create transaction.");
        return;
      }

      alert("Transaction created!");
      setErrorMessage("");
      onClose();
      onSuccess();
    } catch (err) {
      console.error(err);
      setErrorMessage("Something went wrong. Please try again.");
    }
  };

  const handleClose = () => {
    setStep("");
    onClose();
    setErrorMessage("");
  };

  if (!show) return null;

  return (
    <div className="modal fade-modal d-block show" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">
                {step === "in"
                  ? "Create Stock In Transaction"
                  : step === "out"
                  ? "Create Stock Out Transaction"
                  : "Create Storage Transaction"}
              </h5>
              <button type="button" className="btn-close" onClick={handleClose}></button>
            </div>

            <div className="modal-body">
              {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

              {!step ? (
                <div className="text-center py-4">
                  <h6>Select Transaction Type</h6>
                  <div className="d-flex justify-content-center gap-3 mt-3">
                    <button className="btn btn-primary" onClick={() => setStep("in")}>
                      Stock In
                    </button>
                    <button className="btn btn-primary" onClick={() => setStep("out")}>
                      Stock Out
                    </button>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Item</label>
                      <Select
                        options={itemOptions}
                        value={itemOptions.find((opt) => opt.value === Number(form.item_id))}
                        onChange={(selected) =>
                          setForm((prev) => ({ ...prev, item_id: selected?.value || "" }))
                        }
                        placeholder="Search and select item..."
                        isClearable
                      />
                    </div>


                    {step === "out" && (
                      <div className="mb-3">
                        <label className="form-label">Villa</label>
                        <select name="villa_id" className="form-select" value={form.villa_id} onChange={handleChange}>
                          <option value="">-- Select Villa --</option>
                          {villas.map((villa) => (
                            <option key={villa.id} value={villa.id}>{villa.name}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="mb-3">
                      <label className="form-label">Quantity</label>
                      <input type="number" className="form-control" name="quantity" value={form.quantity} onChange={handleChange} />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Date</label>
                      <input type="datetime-local" className="form-control" name="updated_at" value={form.updated_at} onChange={handleChange} />
                    </div>
                  </div>

                  <div className="col-md-6">
                    {step === "in" && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">Supplier Name</label>
                          <input type="text" className="form-control" name="supplier_name" value={form.supplier_name} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Price Per Unit</label>
                          <input type="number" className="form-control" name="price_per_unit" value={form.price_per_unit} onChange={handleChange} />
                        </div>
                      </>
                    )}
                    <div className="mb-3">
                      <label className="form-label">Description</label>
                      <textarea className="form-control" rows="3" name="description" value={form.description} onChange={handleChange}></textarea>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {step && (
              <div className="modal-footer">
                <button className="btn btn-secondary" type="button" onClick={handleClose}>Cancel</button>
                <button className="btn btn-primary" type="submit">Submit</button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
